import { DomainRegistry } from "../../../../domain";
import { IBehaviorDocumentEditorDeleterPostDeletionApplicationConfiguration, IBehaviorDocumentEditorDeleterPostDeletionConfiguration } from "../../../../domain/configuration";
import { ApplicationLaunchRequest } from "../../../../domain/localhost/items";
import { Dictionary } from "../../../../domain/system";
import { User } from "../../../../domain/user";
import { AsyncUtility } from "../../../../utilities";

export class PostDeletionApplicationLauncher {
    constructor(private _configuration: IBehaviorDocumentEditorDeleterPostDeletionConfiguration) {
    }

    public async launch(user: User, documentId: number, patientId: string): Promise<void> {
        for (const application of this._configuration.applications) {
            this.launchApplication(user, documentId, patientId, application);
        }
    }

    private async launchApplication(user: User, documentId: number, patientId: string, application: IBehaviorDocumentEditorDeleterPostDeletionApplicationConfiguration) {
        if (!application.isEnable) { return; }
        const service = DomainRegistry.localhost.getApplicationService();
        const params = new Dictionary<string, string>();
        params.set("action", "launchApplication");
        const request = this.createApplicationLaunchRequest(user, documentId, patientId, application);
        await service.launchWithKey(null, params, request);
        await AsyncUtility.sleep(300);
    }

    private createApplicationLaunchRequest(user: User, documentId: number, patientId: string, application: IBehaviorDocumentEditorDeleterPostDeletionApplicationConfiguration): ApplicationLaunchRequest {
        const request = new ApplicationLaunchRequest();
        request.modulePath = application.modulePath;
        request.argumentsText = this.replaceValues(user, application.parameter, documentId, patientId);
        return request;
    }

    private replaceValues(user: User, parameter: string, documentId: number, patientId: string): string {
        if (!parameter) { return parameter; }
        return parameter
            .replace(/%USERCODE%/g, user.id)
            .replace(/%USERID%/g, user.id)
            .replace(/%PATIENTCODE%/g, patientId)
            .replace(/%PATIENTID%/g, patientId)
            .replace(/%DOCUMENTID%/g, documentId.toString());
    }
}
